/**
 * Selector de período de la Actividad de usuarios (presentacional).
 *
 * Réplica de las pestañas del SSR (`user_activity.html`:
 * "Hoy/Esta semana/Este mes/Últimos 7 días/Histórico"), en su orden. Sin lógica de
 * datos: recibe el período activo y notifica el cambio al padre, que recarga el
 * resumen (la query key incluye el período).
 */
import { Button } from "@/components/ui";

import { PERIOD_OPTIONS } from "../constants";
import type { ActivityPeriod } from "../schemas";

interface PeriodTabsProps {
  value: ActivityPeriod;
  onChange: (period: ActivityPeriod) => void;
}

export function PeriodTabs({ value, onChange }: PeriodTabsProps) {
  return (
    <div
      className="flex flex-wrap gap-1 rounded-lg border border-slate-200 bg-white p-1"
      role="group"
      aria-label="Período"
    >
      {PERIOD_OPTIONS.map((option) => (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={option.value === value ? "primary" : "ghost"}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
